import React, { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import { useLang } from "@/lib/lang";
import { api } from "@/lib/auth";
import { toast } from "sonner";

export default function ForgotPassword() {
    const { t } = useLang();
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await api.post("/auth/forgot-password", { email });
            setSent(true);
        } catch (err) {
            toast.error(t("common.error"));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-ink text-slate-900">
            <Navbar />
            <div className="max-w-md mx-auto px-6 pt-20 pb-24">
                <div className="mono-label mb-4">/ RESET</div>
                <h1 className="font-display text-4xl md:text-5xl mb-3 tracking-tight" data-testid="forgot-title">
                    {t("auth.forgot_title")}
                </h1>
                <p className="text-slate-600 mb-10">{t("auth.forgot_sub")}</p>

                {sent ? (
                    <div className="border border-brand/40 bg-brand/5 rounded-sm p-5 text-sm text-slate-700" data-testid="forgot-sent-msg">
                        {t("auth.forgot_sent")}
                    </div>
                ) : (
                    <form onSubmit={submit} className="space-y-5">
                        <div>
                            <label className="mono-label block mb-2">{t("auth.email")}</label>
                            <input
                                data-testid="forgot-email-input"
                                type="email"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="w-full bg-transparent border border-slate-300 px-4 py-3 rounded-sm focus:border-brand outline-none transition-colors"
                            />
                        </div>
                        <button type="submit" disabled={loading} className="btn-primary w-full justify-center" data-testid="forgot-submit-btn">
                            {loading ? "..." : t("auth.forgot_btn")}
                        </button>
                    </form>
                )}

                <p className="mt-8 text-sm text-slate-500">
                    <Link to="/login" className="text-brand hover:underline" data-testid="forgot-back-login">
                        {t("auth.back_to_login")}
                    </Link>
                </p>
            </div>
        </div>
    );
}
